module.exports = __webpack_public_path__ + "static/media/mobile4.a077b234.png";